import React from "react";
import { cn } from "utils/utils";

const FoilIndicator = ({
  className = "",
  size = 18,
  showTooltip = true,
}: {
  className?: string;
  size?: number;
  showTooltip?: boolean;
}) => {
  const gem = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      className="foil-gem"
      fill="currentColor"
      stroke="none"
      color="#ff6464"
    >
      {/* Main diamond shape */}
      <path d="M 9 2 L 12 7 L 14 12 L 9 16 L 4 12 L 6 7 Z" />

      {/* Center highlight facet */}
      <path d="M 9 2 L 10 9 L 9 16" opacity="0.7" />
    </svg>
  );

  return (
    <div
      className={cn({
        "inline-flex items-center justify-center": true,
        [className]: true,
      })}
    >
      {showTooltip ? (
        <div className="tooltip tooltip-secondary" data-tip="Foil">
          {gem}
        </div>
      ) : (
        gem
      )}
    </div>
  );
};

export default FoilIndicator;
